import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { catchError, switchMap, takeUntil, tap } from "rxjs/operators";
import { ArrayHelper } from "../../utilities/contracts/array-helper";
import { AuthService } from "../auth.service";
import { Auth0Service } from "../auth0.service";

@Component({
  selector: "app-auth0-select-user",
  templateUrl: "./auth0-select-user.component.html",
  styleUrls: ["./auth0-select-user.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Auth0SelectUserComponent implements OnInit, OnDestroy {
  personas: any[] = [];
  hoveredId: number | null = null;
  selectedId: number | null = null;
  isLoading = true;
  private destroy$ = new Subject<void>();

  private orgColors: Record<number, string> = {
    1: "#4f46e5",
    2: "#0891b2",
    9: "#059669",
  };

  constructor(
    private readonly auth0Service: Auth0Service,
    private readonly authService: AuthService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadUserAndPersonas();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getInitials(persona: any): string {
    return ((persona.firstName?.[0] ?? "") + (persona.lastName?.[0] ?? "")).toUpperCase();
  }

  getColor(organizationId: number): string {
    return this.orgColors[organizationId] ?? "#6b7280";
  }

  onMouseEnter(userId: number): void {
    this.hoveredId = userId;
    this.cdr.markForCheck();
  }

  onMouseLeave(): void {
    this.hoveredId = null;
    this.cdr.markForCheck();
  }

  selectPersona(persona: any): void {
    if (this.isLoading) { return; }

    this.selectedId = persona.userId;
    this.isLoading = true;
    this.cdr.markForCheck();

    this.auth0Service.selectPersona(persona)
      .pipe(
        takeUntil(this.destroy$),
        catchError(err => {
          this.selectedId = null;
          this.isLoading = false;
          this.cdr.markForCheck();
          throw err;
        })
      )
      .subscribe(response => {
        this.isLoading = false;
        this.cdr.markForCheck();
        this.authService.loginVerified(response);
      });
  }

  private loadUserAndPersonas(): void {
    this.auth0Service.getUser()
      .pipe(
        switchMap(() => this.auth0Service.getAllPersonas()),
        tap(personas => {
          this.personas = personas;
          this.isLoading = false;
          this.cdr.markForCheck();
        }),
        takeUntil(this.destroy$),
        catchError(err => {
          this.isLoading = false;
          this.cdr.markForCheck();
          throw err;
        })
      )
      .subscribe();
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }

  get isEmpty(): boolean {
    return !this.isLoading && !ArrayHelper.isAvailable(this.personas);
  }
}
